// Import React and third-party libraries first
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

// Then import local components and data
import Box from "../Home/Box.jsx";
import "./About.css";
import AboutImage from "../../assets/General/flute1.jpeg";
import { instructorData } from "./InstructorComponent/InstructorData.jsx";


// Component definitions
const Instructors = () => {
  return (
    <>
      {instructorData.map((instructor, index) => (
        <div key={index}> {/* Added a div wrapper with a key for each instructor */}
          <div>{instructor.paragraphs}</div>
        </div>
      ))}
    </>
  );
};

export default function About() {
  return (
    <div className="home-wrapper">
      <Container style={{ paddingLeft: "4vw", paddingRight: "4vw" }}>
        <Row>
          <Col>
            <Box title="About Us" image={AboutImage} />
          </Col>
        </Row>
        <Instructors />
      </Container>
    </div>
  );
}
